import React, { useState, useEffect } from 'react';
import { Container, Image, Row, Col, Button } from 'react-bootstrap';
import { gql, useQuery, useMutation } from '@apollo/client'
import { message, Radio } from 'antd';
import Footer from './Footer';
import './Content.css';
import { Form, Input, Select } from 'antd';
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { Link, useLocation } from 'react-router-dom';

const PhysicalCardRedeemed = (state) => {


    const { t } = useTranslation();
    const { Option } = Select;
    const location = useLocation();

    return (
        <>
            <Container fluid className='p-4'>
                <Row>
                    <Col md={10}>
                        <Image fluid src='images/Power Logo.png' className='nav-logo' />
                    </Col>
                </Row>
            </Container>
            <Container>

                <Row className="py-5 bps-bg-light justify-content-center text-center">
                    <Col md={6} className="pt-5">
                        <h2 className="bps-midnight fs-48">Visa Reward Card Confirmation</h2>
                        <p className="fs-20">
                        You should receive your card in 10-15 business days.
                        </p>
                    </Col>
                </Row>
                
            </Container>
            <Footer />
        </>
    );
}

export default PhysicalCardRedeemed;